export default __webpack_public_path__ + "static/media/GP.3e9e0f3b.gif";